import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { getTokenFromStorage } from '@/utils/auth';
import {
  getClientNotifications,
  type ClientNotificationActionType,
  type ClientNotificationsResponse,
} from '@/api/beatlyApi';

/**
 * Action types the dashboard's "needs attention" panel currently surfaces.
 * SUMMARY_READY and CAMPAIGN_LAUNCHED are intentionally omitted; the backend
 * still supports them but this surface chooses not to render them.
 */
const DASHBOARD_NOTIFICATION_EVENTS: ClientNotificationActionType[] = [
  'REVIEW_DRAFTS',
  'REVIEW_CURATION',
];

/**
 * GET /app/v2/client/notifications — dashboard "needs attention" rows (client-only).
 */
export function useDashboardNotifications() {
  const { user } = useAuth();
  const token = getTokenFromStorage();
  const enabled = Boolean(token && user?.is_client === true);

  return useQuery({
    queryKey: [
      'dashboard',
      'notifications',
      user?.team?.team_id,
      DASHBOARD_NOTIFICATION_EVENTS,
    ],
    enabled,
    staleTime: 60_000,
    queryFn: async (): Promise<ClientNotificationsResponse> => {
      const authToken = token ?? '';
      return getClientNotifications(authToken, DASHBOARD_NOTIFICATION_EVENTS);
    },
  });
}
